var fontSize = document.documentElement.clientWidth > 1000 ? "16px" : "14px";
var efontSize = document.documentElement.clientWidth > 1000 ? "20px" : "20px";
var height = document.documentElement.clientWidth > 1000 ? "100px" : "120px";
$('#footer-email').css("height", height);
$('#footer-email p').css("font-size", fontSize);
$('#footer-email p a').css("font-size", efontSize);